//import actions from 'store/actions';
import { List, Map, Set } from 'immutable';
import { pipe } from 'ramda';
import { checkAvailSegments } from '../../utils';
import actions from '../../store/actions';

export default {
  GET: () => {
    return (dispatch, getState) => {
      const store = getState();
      const customer = store.get('customer');
      const hotelsIds = customer.get('current_hotels');
      const disabledAmenities = store.getIn(['groupInfo', 'disabled_amenities'], List());
      const disabledBrand = store.getIn(['app','config','disableBrandFilter']);
      const filterSuccessData = ({ avail, descriptive }) =>
        avail.reduce((result, avail, hotelId) => {
          const queryParams = store.getIn(['hotels', hotelId, 'params', store.getIn(["availQuery", "multi", "base_query_params"])]);
          const availData = avail.getIn([queryParams, 'raw_response']);
          const parsedHotelsIds = hotelsIds.map(id => Number(id));
          if (parsedHotelsIds.includes(Number(hotelId)) && checkAvailSegments(availData)) {
            return result.set(
              hotelId,
              Map({
                avail: avail.getIn([queryParams, 'raw_response']),
                descriptive: descriptive.get(hotelId)
              })
            );
          }
          return result;
        }, Map());

      const _updateIn = hotelId => (data, path, name) => {
        const defaultMap = Map({
          name,
          checked: false,
          temporary: false,
          hotels: Set([hotelId])
        });

        return data.updateIn(path, (map = defaultMap) => map.update('hotels', hotels => hotels.add(hotelId)));
      };

      const getFilterData = hotelData => {
        const data = hotelData.reduce(
          (result, data, hotelId) => {

            const descriptive = data.get('descriptive');
            let stars = descriptive.get('stars');
            const amenities = descriptive.get('amenities', List());
            const brand = descriptive.get('brand_name');

            switch (stars) {
              case '5GL':
                stars = '5*';
                break;
              case '':
              case 'Excellence Class':
              case 'Luxury Class':
              case 'Premier Class':
              case '0*':
                stars = 'others';
                break;
              default:
                break;
            }

            const updateIn = _updateIn(hotelId);

            // Amenities
            amenities.forEach(amenity => {
              if (!disabledAmenities.contains(amenity.get("id"))) {
                result = updateIn(result, ['amenities', 'options', amenity.get('code')], amenity.get('name'));
              }
            });

            if (brand && !disabledBrand) {
              result = updateIn(result, ['brand', 'options', brand], brand);
            }
            return result;
          },
          Map({
            brand: Map({
              key: 'brand',
              title: '_%marca%_',
              options: Map()
            }),
            amenities: Map({
              key: 'amenities',
              title: '_%servicios%_',
              options: Map()
            }),

          })
        );

        if (!data.getIn(['brand', 'options']).size) {
          return data.delete('brand');
        }

        return data;
      };


      const sortAmenities = data =>
        data.setIn(['amenities', 'options'], data.getIn(['amenities', 'options']).sortBy(item => item.get('name')));


      const avail = store.get('avail');
      const descriptive = store.get('hotels');

      return Map({
        hotels: Set(hotelsIds),
        options: pipe(
          filterSuccessData,
          getFilterData,
          sortAmenities
        )({ avail, descriptive })
      });
    };
  },
  SET: (type, code, newValue) => {
    return (dispatch, getState) => {
      const getCodePath = field => {
        const path = [type, 'options', code];

        if (field) {
          path.push(field);
        }

        return path;
      };
      const filters = getState().getIn(['customer', 'filters']);
      const options = filters.get('options');

      const data = options.getIn(getCodePath());
      const oldValue = data.get('checked');

      const updateOption = options => {
        if (oldValue === newValue) {
          return options
            .deleteIn(getCodePath('oldValue'))
            .setIn(getCodePath('temporary'))
            .setIn(getCodePath('checked'), newValue);
        } else {
          return options
            .setIn(getCodePath('oldValue'), oldValue)
            .setIn(getCodePath('temporary'), true)
            .setIn(getCodePath('checked'), newValue);
        }
      };

      return Map({
        hotels: filters.get('hotels'),
        options: updateOption(options)
      });
    };
  },
  APPLY: () => {
    return (dispatch, getState) => {
      const options = getState().getIn(['customer', 'filters', 'options']);
      const hotelsIds = getState().getIn(['customer', 'current_hotels']);

      let allUnchecked = true;
      const applyFilters = options =>
        options.reduce(
          (data, filter) => {
            filter.get('options').forEach((option, code) => {
              if (option.get('checked')) {
                allUnchecked = false;
                data.hotels = data.hotels.union(option.get('hotels'));
              }

              if (option.get('temporary')) {
                data.options = data.options.setIn([filter.get('key'), 'options', code, 'temporary'], false);
              }
            });
            return data;
          },
          {
            hotels: Set(),
            options
          }
        );

      let result = Map(applyFilters(options));
      if (allUnchecked) {
        result = result.set('hotels', Set(hotelsIds));
      }

      const eventName = allUnchecked ? 'del_filter' : 'add_filter';
      dispatch(
        actions.events.trigger(eventName, {
          filters: result.get('options').toJS(),
          filteredHotels: result.get('hotels').toJS()
        })
      );

      return result;
    };
  },
  CLEAR: (temporary = false) => {
    return (dispatch, getState) => {
      const store = getState();
      const customer = store.get('customer');
      const hotelsIds = customer.get('current_hotels');
      const options = customer.getIn(['filters', 'options']);

      const defaultValues = {
        checked: false,
        temporary: false
      };

      if (temporary) {
        delete defaultValues.checked;
      }

      const types = ['amenities'];

      if (options.has('brand')) {
        types.push('brand');
      }

      return Map({
        hotels: Set(hotelsIds),
        options: types.reduce(
          (newOptions, type) =>
            newOptions.updateIn([type, 'options'], map =>
              map.reduce((newMap, values, code) => newMap.mergeIn([code], defaultValues), map)
            ),
          options
        )
      });
    };
  },
  UPDATE: () => {
    return (dispatch, getState) => {
      const store = getState();
      const customer = store.get('customer');
      let filters = customer.get('filters');
      return filters;
    };
  }
};
